import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { CONFIRM_DIALOG_COPY } from "../../lib/confirmDialog";

export function ConfirmDialog({
  opened,
  onClose,
  title,
  description,
  confirmLabel,
  confirmColor = "red",
  loading = false,
  confirmDisabled = false,
  onConfirm,
  children,
}: {
  opened: boolean;
  onClose: () => void;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  confirmColor?: string;
  loading?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  children?: ReactNode;
}) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Stack gap="md">
        {typeof description === "string" ? <Text size="sm">{description}</Text> : description}
        {children}
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onClose} disabled={loading}>
            {CONFIRM_DIALOG_COPY.cancel}
          </Button>
          <Button
            color={confirmColor}
            loading={loading}
            disabled={confirmDisabled}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
